import { gql } from '@apollo/client';
const SET_ORDER_SPECIFICATION_PRODUCTION_START_DATE = gql `
  mutation SetOrderSpecificationProductionStartDate(
    $orderId: ID!
    $specificationId: ID!
    $productionStartDate: DateTime
  ) {
    setOrderSpecificationProductionStartDate(
      orderId: $orderId
      specificationId: $specificationId
      productionStartDate: $productionStartDate
    ) {
      specification {
        id
      }
      productionApproved
      productionStartDate
      virtualProductionEndDate
      sumOfModelQuantities
      totalProductionTimeMinutes
      priority
      manufacturer {
        id
        shortName
        fullName
        employeesCount
        picture
        nonWorkingDays {
          id
          startDate
          endDate
        }
      }
      modelsCount
      suppliersCount
      manufacturerOccupiedDates
    }
  }
`;
export default SET_ORDER_SPECIFICATION_PRODUCTION_START_DATE;
